"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 25",
    width: "25",
    height: "25"
  }, props), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "5.2",
    y: "9.8",
    width: "3.1",
    height: "5.4"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M19,17.2H3.7c-0.3,0-0.5-0.2-0.5-0.5V8.3c0-0.3,0.2-0.5,0.5-0.5H19c0.3,0,0.5,0.2,0.5,0.5v1.8h1.8c0.3,0,0.5,0.2,0.5,0.5 v3.8c0,0.3-0.2,0.5-0.5,0.5h-1.8v1.8C19.5,17,19.3,17.2,19,17.2z M4.2,16.2h14.4v-1.8c0-0.3,0.2-0.5,0.5-0.5h1.8v-2.8H19 c-0.3,0-0.5-0.2-0.5-0.5V8.8H4.2V16.2z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12.5,25C5.6,25,0,19.4,0,12.5S5.6,0,12.5,0S25,5.6,25,12.5S19.4,25,12.5,25z M12.5,1C6.2,1,1,6.2,1,12.5S6.2,24,12.5,24 S24,18.8,24,12.5S18.8,1,12.5,1z"
  }));
};

exports["default"] = _default;